import { takeLatest, takeLeading } from 'redux-saga/effects';
import {
  leavesPageRequestedSaga,
  leaveDetailRequestedSaga,
  leaveApplyRequestedSaga,
  leaveUpdateRequestedSaga,
  leaveDeleteRequestedSaga,
  leaveTypesRequestedSaga,
} from './leaves.saga';
import { LeaveActionTypes } from './leaves.types';

export function* leavesSaga() {
  yield takeLeading(LeaveActionTypes.LeavePageRequested, leavesPageRequestedSaga);

  // New saga watchers
  yield takeLatest(LeaveActionTypes.LeaveDetailRequested, leaveDetailRequestedSaga);
  yield takeLatest(LeaveActionTypes.LeaveApplyRequested, leaveApplyRequestedSaga);
  yield takeLatest(LeaveActionTypes.LeaveUpdateRequested, leaveUpdateRequestedSaga);
  yield takeLatest(LeaveActionTypes.LeaveDeleteRequested, leaveDeleteRequestedSaga);
  yield takeLatest(LeaveActionTypes.LeaveTypesRequested, leaveTypesRequestedSaga);
}
